
import Vue from 'vue'
import PurchaseV2 from '@/views/shop-v2/purchase/index.vue'
import LeaveConfirmationDialog from '@/views/shop-v2/purchase/LeaveConfirmationDialog.vue'

export default Vue.extend({
  name: 'PurchaseWrapper',
  components: {
    PurchaseV2,
    LeaveConfirmationDialog,
  },
  data() {
    return {
      isLeaveConfirmationDialogOpen: false,
      pendingNavigation: null as (() => void) | null,
    }
  },
  computed: {
    hasCartItems() {
      const cartItems = this.$store.getters['cart/cartItems']
      return cartItems?.length > 0
    },
  },
  methods: {
    handleBeforeUnload(event: BeforeUnloadEvent) {
      // Only show native dialog if dialog is not already open
      // This handles cases where user closes tab/clicks browser refresh button
      if (this.hasCartItems && !this.isLeaveConfirmationDialogOpen) {
        event.preventDefault()
        event.returnValue = this.$t(
          'purchaseV2.leaveConfirmation.message',
        ) as string
        return event.returnValue
      }
    },
    closeLeaveConfirmationDialog() {
      this.isLeaveConfirmationDialogOpen = false
      this.pendingNavigation = null
    },
    confirmLeave() {
      this.isLeaveConfirmationDialogOpen = false
      this.$store.dispatch('cart/resetCart')
      if (this.pendingNavigation) {
        this.pendingNavigation()
        this.pendingNavigation = null
      }
    },
  },
  beforeRouteLeave(_to, _from, next) {
    // No basket items: leave without prompting, but still clear any lingering
    // cart state (e.g. a selected customer) so it doesn't leak into the next
    // visit to Purchase. With items, the confirmation dialog resets on confirm.
    if (!this.hasCartItems) {
      this.$store.dispatch('cart/resetCart')
      return next()
    }
    this.pendingNavigation = () => next()
    this.isLeaveConfirmationDialogOpen = true
    next(false)
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
})
